import { useRouter } from "next/router";
import { useEffect } from "react";

export const Redirect = ({ path }: { path: string }) => {
  const router = useRouter();

  useEffect(() => {
    router.replace(path);
  }, []);

  return <></>;
};
